module.exports = __webpack_public_path__ + "img/katarina_bedrooms_28.75e93968.jpg";